module.exports = __webpack_public_path__ + "static/media/siri06.0e76bb4a.jpg";